import request from '@/utils/request.js'

/**
 *根据参数获取 试题类型
 * @param params
 * @returns {AxiosPromise}
 */
export function getTypeByParams(params) {
    return request({
        closeLoading:true,
        url: '/studyService/api/app/question/getTypeByParams',
        method: 'post',
        data: params
    })
}

// 根据试题id 获取json
export function combinationQuestionContextCollection(params) {
    return request({
        closeLoading:true,
        url: '/studyService/api/app/newQuestion/combinationQuestionContextCollection',
        method: 'post',
        data: params
    })
}

/**
 *运营包/课程包 试卷-- 练习册json 1,2
 * @param params
 * @returns {AxiosPromise}
 */
//之前的一次性获取数据
export function getOperateCourseTestPaperQuestions(params) {
    return request({
        url: '/studyService/api/app/question/getOperateCourseTestPaperQuestions',
        method: 'post',
        data: params
    })
}
//框架
export function getOperateCourseTestPaperNew(params) {
    return request({
        closeLoading:true,
        url: '/studyService/api/app/newQuestion/getOperateCourseTestPaperQuestionsNew',
        method: 'post',
        data: params
    })
}



/**
 *原子课习题-- 练习册json 3,4
 * @param params
 * @returns {AxiosPromise}
 */
export function getAtomicCourseQuestions(params) {
    return request({
        url: '/studyService/api/app/question/getAtomicCourseQuestions',
        method: 'post',
        data: params
    })
}
//框架
export function getAtomicCourseQuestionsNew(params) {
    return request({
        closeLoading:true,
        url: '/studyService/api/app/newQuestion/getAtomicCourseQuestionsNew',
        method: 'post',
        data: params
    })
}

/**
 *我的课程知识点--知识点习题json 5，6
 * @param params
 * @returns {AxiosPromise}
 */
export function getQuestionsByKnowledgeIdVo(params) {
    return request({
        url: '/studyService/api/app/question/getQuestionsByKnowledgeIdVo',
        method: 'post',
        data: params
    })
}

//框架
export function getQuestionsByKnowledgeIdVoNew(params) {
    return request({
        closeLoading:true,
        url: '/studyService/api/app/newQuestion/getQuestionsByKnowledgeIdVoNew',
        method: 'post',
        data: params
    })
}


/**
 *营包/课程包试卷习题--提交1,2
 * @param params
 * @param closeLoading
 * @returns {AxiosPromise}
 */
export function submitQuestionByOperateCourseTestPaperQuestion(params,closeLoading = false) {
    return request({
        closeLoading:closeLoading,
        url: '/studyService/api/app/question/submitQuestionByOperateCourseTestPaperQuestion',
        method: 'post',
        data: params
    })
}


/**
 *原子课习题--提交练习--提交3,4
 * @param params
 * @param closeLoading
 * @returns {AxiosPromise}
 */
export function submitQuestionByAtomicCourse(params,closeLoading = false) {
    return request({
        closeLoading:closeLoading,
        url: '/studyService/api/app/question/submitQuestionByAtomicCourse',
        method: 'post',
        data: params
    })
}




/**
 *我的课程知识点--知识点提交练习--提交5,6
 * @param params
 * @param closeLoading
 * @returns {AxiosPromise}
 */
export function submitKnowledgeQuestion(params,closeLoading = false) {
    return request({
        closeLoading:closeLoading,
        url: '/studyService/api/app/question/submitKnowledgeQuestion',
        method: 'post',
        data: params
    })
}



/**
 *运营包/课程包试卷--重新挑战
 * @param params
 * @returns {AxiosPromise}
 */
export function getOperateCourseTestPaperQuestionsJsonArrNew(params) {
    return request({
        url: '/studyService/api/app/newQuestion/getOperateCourseTestPaperQuestionsJsonArrNew',
        method: 'post',
        data: params
    })
}


/**
 *原子课习题--重新挑战--重新挑战
 * @param params
 * @returns {AxiosPromise}
 */
export function getAtomicCourseQuestionsJsonArrNew(params) {
    return request({
        url: '/studyService/api/app/newQuestion/getAtomicCourseQuestionsJsonArrNew',
        method: 'post',
        data: params
    })
}

/**
 *我的课程知识点--重新挑战--重新挑战
 * @param params
 * @returns {AxiosPromise}
 */
export function getQuestionsByKnowledgeIdVONew(params) {
    return request({
        url: '/studyService/api/app/newQuestion/getQuestionsByKnowledgeIdVONew',
        method: 'post',
        data: params
    })
}



/**
 *我的课程知识点--重新挑战--重新挑战
 * @param params
 * @returns {AxiosPromise}
 */
export function updateStudyScheduleTestPaper(params) {
    return request({
        url: '/studyService/api/userCourseValidity/updateStudyScheduleTestPaper',
        method: 'post',
        data: params
    })
}



